import { render, staticRenderFns } from "./DepartmentRuleList.vue?vue&type=template&id=0acc6c20"
import script from "./DepartmentRuleList.vue?vue&type=script&lang=js"
export * from "./DepartmentRuleList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentRuleList.vue?vue&type=style&index=0&id=0acc6c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports